import React, {useEffect, useState} from "react";
import { Navbar, Footer } from "./../../Components";
import Banner from "./../../Containers/PageBlog/Banner";
import Blog from "./../../Containers/PageBlog/Blog";
//import ForWish from "../../Containers/Faq/";
import {useLocation} from "react-router-dom";
import {useInfiniteQuery, useQuery} from "react-query";
import api from "../../Services/api";
import {generateSlug} from "../../Services/tools";
import DocumentMeta from "react-document-meta";

function PageBlog() {
    const params = useLocation();
    const nameuri =params.pathname.split("/").pop()
    const [meta,setMeta]=useState({})
    console.log(nameuri)
    const { isLoading,
        isError,
        error,
        data:dataBlog,
        isFetching,
        isPreviousData, } = useQuery(['repoBlog',nameuri], ()=> api.getBlog(nameuri),{ keepPreviousData : true })
    useEffect(()=>{
        setMeta({
            title: dataBlog?.data?.metaTitle+' - Vignitus',
            description: dataBlog?.data?.metaDescription,
            canonical: 'https://vignitus.fr/blog/'+nameuri,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'Vignitus, Blog'
                }
            }
        })
    },[dataBlog])
    return (
        <DocumentMeta {...meta}>
            <div>
              <Navbar />
              <div className="content-wraper">
                <Banner title={dataBlog?.data?.title} />
                <Blog item={dataBlog?.data}/>
              </div>
              <Footer />
            </div>
        </DocumentMeta>
  );
}

export default PageBlog;
